// extracted by mini-css-extract-plugin
export default {"link":"SidebarLink_link__aTAj7","primary":"SidebarLink_primary__451yS","secondary":"SidebarLink_secondary__g0Vaa","selected":"SidebarLink_selected__W1etT"};